import { f7, useStore } from "framework7-vue";
import utils from "./utils";
import store from "./store";

let checkEndFreeTrial = () => {
  const suscripcion = useStore("suscripcion");
  let endFreeTrial = new Date(
    `${suscripcion.value.vencimiento_suscripcion}T00:00:00`
  );
  let currentSuscription = suscripcion.value.nombre_suscripcion_actual;
  let suscriptionStatus = suscripcion.value.estado_suscripcion;
  let alreadyDismissed = localStorage.getItem("dismiss_end_free_trial");
  let alreadyDismissedExpired = localStorage.getItem("dismiss_end_free_trial_expired");
  let daysDiff = Math.floor((endFreeTrial - Date.now()) / (1000 * 60 * 60));


  // if (currentSuscription === "Pro" && suscriptionStatus === "Activo") {
  //   return;
  // } else if (currentSuscription !== "Gratuito" && suscriptionStatus === "Vencido") {
  //   store.dispatch("setOpenEndFreeTrialSheet", true);
  // } else if (currentSuscription === "Pro" && suscriptionStatus === "Cancelado") {
  //   store.dispatch("setOpenEndFreeTrialSheet", true);
  // }


  if (currentSuscription === "Gratuito" && daysDiff <= 24 && daysDiff >= 0) {
    if (!alreadyDismissed || alreadyDismissed === false) {
      store.dispatch("setOpenEndFreeTrialSheet", true);
    }
  }

  if (currentSuscription === "Gratuito" && daysDiff < 0) {
    if (!alreadyDismissedExpired || alreadyDismissedExpired === false) {
      store.dispatch("setOpenEndFreeTrialExpiredSheet", true);
    }
  }
};

let checkSuscription = () => {
  // const suscripcion = useStore("suscripcion");
  // if (suscripcion.estado_suscripcion !== "Activo") {
  //   store.dispatch("setDisabledSuscriptionSheet", true);
  // }
};

export default {
  checkEndFreeTrial,
  checkSuscription,
};
